import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
const APPLIED_FOR_RESEARCH_OPTIONS = [{
  key: 'not_specified',
  value: '',
  text: 'not_specified'
}, {
  key: 'yes',
  value: 'yes',
  text: 'yes'
}, {
  key: 'no',
  value: 'no',
  text: 'no'
}];
const AffiliatedCompanyForm = _ref => {
  var _affiliatedCompany$ap;
  let {
    handleChange,
    affiliatedCompany,
    handleSubmit,
    closeForm
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TextFormFieldRow, {
    fieldName: "tax_number",
    label: "affiliated_company_tax_number",
    value: affiliatedCompany.tax_number,
    onChange: handleChange,
    dataTestId: "affiliated_company_tax_number"
  }), /*#__PURE__*/React.createElement(TextFormFieldRow, {
    fieldName: "name",
    label: "affiliated_company_name",
    value: affiliatedCompany.name,
    onChange: handleChange,
    dataTestId: "affiliated_company_name"
  }), /*#__PURE__*/React.createElement(TextFormFieldRow, {
    fieldName: "country",
    label: "country",
    value: affiliatedCompany.country,
    onChange: handleChange,
    dataTestId: "affiliated_company_country"
  }), /*#__PURE__*/React.createElement(TextFormFieldRow, {
    fieldName: "tax_number_country",
    label: "tax_number_country",
    value: affiliatedCompany.tax_number_country,
    onChange: handleChange,
    dataTestId: "affiliated_company_tax_number_country"
  }), /*#__PURE__*/React.createElement(TextFormFieldRow, {
    fieldName: "tax_office",
    label: "tax_office",
    value: affiliatedCompany.tax_office,
    onChange: handleChange,
    dataTestId: "affiliated_company_tax_office"
  }), /*#__PURE__*/React.createElement(Dropdown, {
    name: "applied_for_research_allowance",
    fieldName: "applied_for_research_allowance",
    label: "applied_for_research_allowance",
    value: (_affiliatedCompany$ap = affiliatedCompany.applied_for_research_allowance) !== null && _affiliatedCompany$ap !== void 0 ? _affiliatedCompany$ap : '',
    onChange: val => handleChange({
      target: {
        name: 'applied_for_research_allowance',
        value: val === '' ? null : val
      }
    }),
    options: APPLIED_FOR_RESEARCH_OPTIONS,
    dataTestId: "affiliated_company_applied_for_research_allowance",
    showNullOption: false
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('maximum_eligible_assessment_basis')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(FormattedNumberInput, {
    value: affiliatedCompany.maximum_eligible_assessment_basis,
    name: "maximum_eligible_assessment_basis",
    onChange: handleChange,
    onlyPositiveNumbers: true,
    thousandSeparator: ".",
    decimalSeparator: ",",
    size: "md",
    "data-testid": "maximum_eligible_assessment_basis"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('date_of_application')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'date_of_application'
      }
    }),
    selected: affiliatedCompany.date_of_application
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('date_of_the_decision')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'date_of_the_decision'
      }
    }),
    selected: affiliatedCompany.date_of_the_decision
  }))))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleSubmit(),
    icon: "save",
    iconPosition: 'left',
    variant: "primary"
  }, t('save')), /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: () => closeForm(),
    variant: "light"
  }, t('close_form')))));
};
export default AffiliatedCompanyForm;